<template>
  <Loader v-if="loading && editMode"></Loader>
  <div v-else>
    <Breadcrumb :items="items" />
    <noData v-if="noData" />
    <div class="form countryForm custom_card fadeIn" v-else>
      <form @submit.prevent="validateCreateForm">
        <div class="row">
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                @keypress="isArabic"
                type="text"
                class="form-control"
                @input="helper_checkIfInputIsEmpty"
                v-model.trim="data.name_ar"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.name_ar") }}
              </label>
            </div>
          </div>
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                @keypress="isEnglish"
                type="text"
                class="form-control"
                @input="helper_checkIfInputIsEmpty"
                v-model.trim="data.name_en"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.name_en") }}
              </label>
            </div>
          </div>
          <div class="col-12 mt-5">
            <h4 class="mb-4 d-flex align-items-center">
              <i
                class="fal fa-shield-check mr-2"
                style="color: var(--main)"
              ></i>
              {{ $t("forms.labels.permission_categories") }}
            </h4>
            <div class="row">
              <div
                class="col-md-6 col-lg-4 mb-4"
                v-for="(row, index) in permission_categories"
                :key="index"
              >
                <v-card
                  class="permission-card h-100 elevation-2 rounded-lg transition-swing"
                >
                  <div class="permission-card-header text-capitalize">
                    <v-checkbox
                      v-model="row.allSelected"
                      @change="toggleAllRowPermissions(row)"
                      :label="row.title"
                      color="primary"
                      hide-details
                      class="font-weight-bold ma-0 pa-0 custom-checkbox"
                    ></v-checkbox>
                  </div>
                  <v-divider class="mx-3"></v-divider>
                  <div class="permission-card-body px-4 py-3">
                    <div
                      class="permission-item py-1"
                      v-for="permission in row.permissions"
                      :key="permission.id"
                    >
                      <v-checkbox
                        color="success"
                        v-model="permission.status"
                        @change="checkRowSelection(row)"
                        :label="permission.title"
                        hide-details
                        class="ma-0 pa-0"
                      ></v-checkbox>
                    </div>
                  </div>
                </v-card>
              </div>
            </div>
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="button_style_1" :disabled="btnIsLoading">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
        <!-- <base-button type="submit" @click="submit" class="center"></base-button> -->
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",
  props: ["id"],
  data() {
    return {
      noData: false,
      loading: false,
      btnIsLoading: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.roles.title"),
          disabled: false,
          href: "/role/show-all",
        },
        {
          text: this.$t("breadcrumb.roles.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading

      // ========== create_data
      data: {
        name_ar: null,
        name_en: null,
        permission_row: [],
      },

      permission_categories: [],
    };
  },
  computed: {
    editMode() {
      return !!this.id;
    },
  },

  methods: {
    resetForm() {
      this.data.name_ar = null;
      this.data.name_en = null;
    },

    //validate Form
    validateCreateForm() {
      if (!this.data.name_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.title_ar"),
          position: "bottomRight",
        });
        return;
      } else if (!this.data.name_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.title_en"),
          position: "bottomRight",
        });
        return;
      }

      this.submitData();
    },
    // Submit Data
    submitData() {
      this.btnIsLoading = true;
      const frmData = new FormData();

      frmData.append(`ar[name]`, this.data.name_ar);
      frmData.append(`en[name]`, this.data.name_en);

      let main_index = 0;
      this.permission_categories.map((row) => {
        if (row.permissions) {
          row.permissions.map((el) => {
            if (el.status) {
              ++main_index;
              frmData.append(`permission_ids[${main_index}]`, el.id);
            }
          });
        }
      });

      if (this.id) {
        frmData.append("_method", "PUT");
      }
      let url = "";

      if (this.id) {
        url = `role/${this.id}`;
      } else {
        url = "role";
      }

      let message = this.id ? this.$t("editSuccess") : this.$t("addSuccess");

      this.$axios
        .post(url, frmData)
        .then(() => {
          this.$iziToast.success({
            title: this.$t("success"),
            message: message,
          });
          this.$router.push("/role/show-all");
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.btnIsLoading = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message ?? err.response.data.messages,
            position: "bottomRight",
          });
        });
    },
    getEditData() {
      this.noData = false;
      if (this.editMode) {
        this.loading = true;
        this.$axios({
          method: "GET",
          url: `role/${this.id}`,
        })
          .then((res) => {
            this.loading = false;
            const result = res.data.data;
            this.data.name_ar = result.ar ? result.ar.name : result.name || "";
            this.data.name_en = result.en ? result.en.name : result.name || "";

            let activePermissions =
              result.permissions || result.permission || [];

            // Robust loop: Handles if `activePermissions` is an array of objects (with `id`) or just an array of IDs
            activePermissions.forEach((el) => {
              let targetId = typeof el === "object" ? el.id : el;

              this.permission_categories.forEach((row) => {
                if (row.permissions) {
                  let sub = row.permissions.find((p) => p.id == targetId);
                  if (sub) {
                    this.$set(sub, "status", true);
                  }
                }
              });
            });

            this.permission_categories.forEach((row) => {
              this.checkRowSelection(row);
            });
          })
          .catch((err) => {
            let errorMsg =
              err.response?.data?.message ||
              err.response?.data?.messages ||
              err.message ||
              "An unexpected error occurred.";
            this.$iziToast.error({
              title: this.$t("error"),
              message: errorMsg,
            });
            this.noData = true;

            this.loading = false;
          });
      }
    },
    toggleAllRowPermissions(row) {
      if (row.permissions) {
        row.permissions.forEach((p) => {
          p.status = row.allSelected;
        });
      }
    },
    checkRowSelection(row) {
      if (row.permissions) {
        row.allSelected =
          row.permissions.length > 0 && row.permissions.every((p) => p.status);
      }
    },
    getCategories() {
      this.$axios.get("permission").then((res) => {
        let responseData = res.data.data;
        let categories = [];

        // Convert object mapping to array
        if (
          responseData &&
          typeof responseData === "object" &&
          !Array.isArray(responseData)
        ) {
          for (const key in responseData) {
            categories.push({
              title: key,
              permissions: responseData[key],
            });
          }
        } else if (Array.isArray(responseData)) {
          categories = responseData; // Fallback just in case
        }

        if (categories.length > 0) {
          categories.forEach((row) => {
            this.$set(row, "allSelected", false);
            if (row.permissions) {
              row.permissions.forEach((p) => {
                this.$set(p, "status", false);
              });
            }
          });
        }
        this.permission_categories = categories;

        if (this.id) {
          this.getEditData();
        }
      });
    },
  },

  async created() {
    this.control = this.$permission.setControls(this.$route.path);
    await this.getCategories();
  },
};
</script>
<style lang="scss">
.permission-card {
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03) !important;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06) !important;
    border-color: var(--main);
  }

  .permission-card-header {
    background: rgba(0, 0, 0, 0.015);
    padding: 12px 16px;
    border-radius: 8px 8px 0 0;

    .v-label {
      font-size: 1.1rem;
      font-weight: 600;
      color: #333;
      letter-spacing: 0.5px;
    }
  }

  .permission-card-body {
    .permission-item {
      transition: background 0.2s;
      border-radius: 4px;
      padding-inline: 4px;

      &:hover {
        background: rgba(0, 0, 0, 0.02);
      }

      .v-label {
        font-size: 0.95rem;
        color: #555;
      }
    }
  }
}

// Custom checkbox sizing
.custom-checkbox .v-input--selection-controls__input {
  margin-right: 8px !important;
}
html[dir="rtl"] .custom-checkbox .v-input--selection-controls__input {
  margin-right: 0 !important;
  margin-left: 8px !important;
}
</style>
